import * as React from 'react';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';

export default function StaticCurrentDate() {
  const currentDate = dayjs().format('DD MMM YYYY');
  const dayName = dayjs().format('dddd');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.2,
        px: 2,
        py: 0.8,
        borderRadius: '10px',
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: (theme) =>
          theme.palette.mode === 'dark'
            ? 'rgba(255,255,255,0.05)'
            : '#f5f7fa',
        cursor: 'default',
        userSelect: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: 'primary.main',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      }}
    >
      <CalendarTodayRoundedIcon
        sx={{
          fontSize: 18,
          color: 'primary.main',
        }}
      />
      <Box>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '0.8rem',
            color: 'text.primary',
            lineHeight: 1.2,
          }}
        >
          {currentDate}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.65rem',
            color: 'text.secondary',
            lineHeight: 1.2,
          }}
        >
          {dayName}
        </Typography>
      </Box>
    </Box>
  );
}